import React, { useEffect, useState } from "react";
import { useParams } from "react-router";
import { Link } from "react-router-dom";
import { useAppEvenListSelector, useAppGameDetailsSelector } from "src/_common/hooks/selectors/eventSelector";
import { CRYPTO_SECRET_KEY } from "src/_config";

// interface SponsorProps {
//     details?: any
// }

const Cryptr = require("cryptr");
const cryptr = new Cryptr(CRYPTO_SECRET_KEY);

export default function Sponsor() {
  const [details, setDetails] = useState<any>();
  const [link, setLink] = useState<any>();
  const { eventId } = useParams<any>();

  const gameDetails = useAppGameDetailsSelector();
  const eventList = useAppEvenListSelector();

  useEffect(() => {
    // console.log({details})
  }, [details]);

  useEffect(() => {
    if (eventId) {
      let e_id = parseInt(cryptr.decrypt(eventId));
      let r_event = eventList?.list?.find((x: any) => x.id == e_id);
      console.log({ r_event });
      setLink(r_event?.rodeo_event_game_info?.sponsor_link);
      if (r_event?.rodeo_event_game_info?.sponsor) {
        setDetails(r_event?.rodeo_event_game_info?.sponsor);
      }
    } else {
      console.log({ gameDetails });
      setLink(gameDetails?.sponsor_link);
      if (gameDetails?.sponsor_image) {
        setDetails(gameDetails?.sponsor_image);
      }
    }
  }, [eventId, gameDetails, eventList]);

  return (
    <>
      {details?.id != 0 && details?.original ? (
        <div className="sponsor-com-img-wrap">
          <span>Sponsored by:</span>
          {link ? (
            <a href={link}>
              <img src={details?.original} alt="Sponsor Image" />
            </a>
          ) : (
            <a>
              <img src={details?.original} alt="Sponsor Image" />
            </a>
          )}
        </div>
      ) : null}
    </>
  );
}
